import React, { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { Languages, Menu, X } from "lucide-react";
import { trackPreEnrollmentClick } from "../lib/analytics";

const Navbar = () => {
  const { lang, toggle, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#inicio", label: t.nav.home, id: "home" },
    { href: "#nosotros", label: t.nav.about, id: "about" },
    { href: "#programa", label: t.nav.program, id: "program" },
    { href: "#actividades", label: t.nav.activities, id: "activities" },
    { href: "#summer-camp", label: t.nav.summer, id: "summer" },
    { href: "#inscripciones", label: t.nav.pricing, id: "pricing" },
    { href: "#galeria", label: t.nav.gallery, id: "gallery" },
    { href: "#contacto", label: t.nav.contact, id: "contact" },
  ];

  return (
    <header
      data-testid="main-nav"
      style={{ top: "var(--banner-h, 0px)" }}
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-2xl border-b border-[#E2E8F0]/60 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#inicio" data-testid="nav-logo" className="flex items-center gap-3 md:gap-4 shrink-0">
          <img
            src="/images/logo.jpg"
            alt="Logo Centro Pedagógico Infantil STEPS"
            className="w-14 h-14 md:w-16 md:h-16 rounded-2xl object-contain bg-white border border-[#E2E8F0] shadow-sm"
          />
          <div className="leading-tight hidden xl:block">
            <div className="font-fredoka text-sm font-semibold text-[#1D3557] tracking-tight">
              Centro Pedagógico Infantil
            </div>
            <div className="font-fredoka text-2xl font-bold text-[#1E5FBA] leading-none">STEPS</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-[14px] xl:text-[15px] font-medium text-[#1D3557] hover:text-[#1E5FBA] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            data-testid="language-toggle"
            className="flex items-center gap-2 rounded-full bg-white border border-[#E2E8F0] px-4 py-2 text-sm font-semibold text-[#1D3557] hover:border-[#1E5FBA] hover:text-[#1E5FBA] transition-colors"
            aria-label="Change language"
          >
            <Languages className="w-4 h-4" strokeWidth={2.5} />
            <span>{lang.toUpperCase()}</span>
          </button>
          <a
            href="#contacto"
            data-testid="nav-cta"
            onClick={() => trackPreEnrollmentClick("navbar")}
            className="hidden md:inline-flex items-center rounded-full bg-[#1D3557] hover:bg-[#1E5FBA] text-white px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            {t.nav.cta}
          </a>
          <button
            className="lg:hidden grid place-items-center w-10 h-10 rounded-xl bg-white border border-[#E2E8F0]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#E2E8F0] px-6 py-4" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                className="text-base font-medium text-[#1D3557] hover:text-[#1E5FBA]"
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.id}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
